import React, { useRef } from "react";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Slide from "@mui/material/Slide";

import { useTheme } from "@emotion/react";

import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

export const SlidingContainer = ({
  position,
  changePosition,
  firstElement,
  secondElement
}) => {
  const theme = useTheme();
  const containerRef = useRef(null);

  return (
    <Box ref={containerRef}>
      <Slide in={position === "first"} appear={false} direction="down" container={containerRef.current}>
        <Box id="firstElement" height="86vh" position="relative" top={0} left={0}>
          {firstElement()}
        </Box>
      </Slide>
      <Slide in={position === "second"} direction="up" container={containerRef.current}>
        <Box id="secondElement" height="86vh" position="relative" top="-86vh" left={0}>
          <Box component="span" display="flex" justifyContent="center" mb={1}>
            <Button 
              variant="contained"
              onClick={() => changePosition("first")} 
              endIcon={<ArrowUpwardIcon fontSize="large" />} 
              sx={{ "& .MuiButton-endIcon": { position: "relative", bottom: "2px" }, position: "relative", bgcolor: "primary", boxShadow: 0 }}
            >
              Back to Machines
            </Button>
          </Box>
          <Paper sx={{ border: `5px solid ${theme.palette.primary.light}`, borderRadius: "8px", padding: theme.spacing(1) }} elevation={2}>
            {secondElement()}
          </Paper>
        </Box>
      </Slide>
    </Box>
  );
};
